module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("In which I am told an extraordinary fortune")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("June 23, 1777—Trois-Ilets, Martinico.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I am fourteen today and unmarried still. Without a dowry, what hope is there? Mother says the wind takes hope and dashes it into the sky, just as the big wind took our house, picked it up and dashed it, leaving nothing but debts in its place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oh, what a black mood has possessed me. Is not the celebration of one’s birthday supposed to bring one joy? After dinner, after eating too many doughnut fritters with guava jelly, I took my leave and climbed up to my special place in the kapok tree. It was cool in the shade of the leaves. I could hear Grandmother Sannois and Mother arguing in the front parlor, the slaves chanting as they pushed the cane stalks through the rollers in the crushing hut, a chicken scratching in the honeysuckle bushes. I felt strange up there—peering out at my world, enveloped in gloom on my happy day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s the voodoo, surely, the bitter-tasting quimbois Mimi got me to drink this morning, a drink of secret spells. “Something manbo Euphémie made for you,” she whispered. She’d knotted a red and yellow scarf tight around her head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Euphémie David—the teller of fortunes?” The obeah woman, the voodoo priestess who lived in the shack up the river.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mimi pushed the coconut bowl into my hands. “It will bring you a "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("man.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I regarded the liquid cautiously, for it smelled vile.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("“Quick!” She glanced over her shoulder. For Mother doesn’t hold with voodoo. Mother says the Devil speaks through the mouths of the voodoo ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("spirits. Mother says the Devil is hungry for girls like me. Mother says the Devil sent her too many girls and is hungry to get one back.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("So this is confession number one in this, my new diary, sent to me all the way from Paris by my beautiful Aunt Désirée: I drank a magic potion and I’ll not tell Mother. I drank a magic potion and I’m filled with woe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A note Aunt Désirée enclosed with her gift read: “A little book in which to record your wishes and dreams, your secret confessions.” I shook the book over the table. Ten livres fell out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Confessions?” my sister Catherine asked. She is twelve now, almost thirteen, but even so, always into mischief. At convent school the nuns make a fuss over Catherine. They don’t know it is Catherine who lets the chicken into the rectory, that it is Catherine who steals the sugar cakes before they are cooled. Catherine has the soul of a trickster, Mimi says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell us your wish,” my youngest sister, Manette, said, lisping through the gap in her teeth. I was saddened by the light in her eyes, for she is only ten, young enough to believe that wishes are granted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I shrugged. “My wish is the same every year.” I glanced at Father. He had started the day with rum and absinthe and followed it with ti-punches all through the afternoon. “To go to France.” Send Rose to France, my beautiful Aunt Désirée would write every year—send her to me, to "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Paris.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Father looked away. His skin was yellow; it is the malaria again, surely. So then I felt bad, for is it Father’s fault he’d inherited only debts? Is it his fault he has been cursed with three daughters and no son, that Mother’s dowry turned to dust in his hands, that his dream of sending me to France had never materialized for want of the price of passage?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“France!” Grandmother Sannois pushed her two pug dogs off her lap. “I’d keep that girl well away from Madame Désirée.” Grandmother Sannois doesn’t approve of Aunt Désirée, or any of the Taschers for that matter ("), _c('span', {
    staticClass: "txit"
  }, [_vm._v("especially")]), _vm._v(" Father). “What’s wrong with that boy over near Laniantin,” she said, downing her laudanum: seven drops in a jigger of brandy. “What’s wrong with that Beal boy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Algernon Beal! The fat boy we all call Algie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Monsieur Beal requires a dowry,” Mother said.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("“Monsieur "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("de")]), _vm._v(" Beal, I believe it is now,” Father said, “the manufacturer of shackles and branding irons, the owner of three gilded carriages, twenty-two ")]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("fighting cocks, an English Thoroughbred stallion and one dim-witted son.” Father coughed and emptied his glass. “Monsieur "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("de")]), _vm._v(" Beal and I had occasion to converse at the slave auction in Fort-Royal last month. He told me at "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("length")]), _vm._v(" and in great "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("detail")]), _vm._v(" how large a girl’s dowry would have to be, how noble her bloodline, how abundant her bosom and intact her maiden-hood even to dream of marrying his pimple-faced boy—”")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Manette had her napkin stuffed in her mouth to keep from laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, there’s always the convent,” Grandmother Sannois said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("The convent.")]), _vm._v(" Always the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("convent.")]), _vm._v(" Is this to be my future? I yearn for so much more! But it’s too late now, I know, for on this, my fourteenth birthday, Aunt Désirée made no offer, and, for the first time since I can remember, Father made no promise . . . and I liked it better before, to tell the truth, with glittering false hopes to brighten my day.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("June 24.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This morning I gave my ten livres to the slave-master to divide among the field-hands. I am grown now and more aware of the sufferings of the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Mother found out and got cross, accusing me of being like Father. “Generous” Father who would let his family starve to feed a friend. “Crazy” Father with his wild stories and dreams of glory. “Dreams from the rum god,” she cursed. “Promises like clouds on a summer day.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Father who is never home. Already he’s off to Fort-Royal—“to play games with the Devil,” Grandmother Sannois said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“To play games with the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("she")]), _vm._v("-devils,” Mother said quietly under her breath.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Sunday, June 29.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Dear Diary, I have been giving thought to my sins, making repentance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am guilty of wishful thinking, of extravagant imaginings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am guilty of gazing at myself in the pond.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am guilty of sleeping with my hands under my bedsheets.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There, it is written. The ink is drying as I write. I must close this book now—I cannot bear to look at these words.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Sunday, July 6.")])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Mademoiselle Tascher,” Father Droppet called to me after church this morning. “Your grandmother asked me to talk to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I fingered the pages of my missal. Outside I heard a horse whinny and a man shouting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You are coming to an age of decision,” he said. His big nose twitched.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, Father.” I could see the outline of his vest under his white frock.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He paused. “I advise you to bend to God’s will, to accept a life of service.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I felt my cheeks becoming heated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Father Droppet handed me a handkerchief. “The life of a nun might satisfy that hungry heart of yours.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Through the high open window I could see the head of the statue of Christ in the cemetery, His eyes looking up at the clouds. The hunger I felt was for fêtes and silk slippers, for the love of a comely beau.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He bent toward me. “I was young once, too,” he said. I could smell rum on his breath.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I would die in a convent!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Forgive me, Father.")]), _vm._v(" I backed away. At the door I turned and ran.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("July 24.")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("This afternoon Mimi and I were playing in the ruins"), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn16",
      "id": "fn-16"
    }
  }, [_vm._v("I")]), _vm._v(" when Mimi saw a spot on my chemise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I twisted and pulled my skirt around. Blood?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s the flowers,” Mimi said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn’t know what to do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell your mother,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can’t do that!” Mother is proper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So Mimi got me a rag which she instructed me on how to use. She told me she washes hers out in the creek, early, when no one is around to see.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where we bathe?” How disgusting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Farther down the river.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("I move around the house aware of this great cloth between my legs, thinking that surely everyone notices. This is supposed to be the big change in me, but all I feel is ill.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Saturday.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mimi is teaching me how to tell the future from cards, how to lay them out, how to know the meaning. Today we practised on my sister Catherine. The card in the ninth place was Death.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Catherine protested.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s not "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("really")]), _vm._v(" death,” Mimi said, taking up the cards. She sniffed the air.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Later, I questioned her. “Why did you stop?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Didn’t you smell cigar smoke?” she whispered. “The spirit of Death is a trickster. Never believe "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Thursday, July 31.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Dear Diary, something terrible has happened; it hangs over my heart like a curse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It began with a lie. I told my little sister Manette that Mimi and I were going to the upper field to see if Father’s ship was in the harbour yet. “You stay here,” I told her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mimi and I headed up the trace behind the manioc hut, but at the top of the hill we took the path that led back down to the river, toward Morne Croc-Souris. We hadn’t gone far when Manette caught up with us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I told you to stay,” I told her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You lied. You said you were going up the hill.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mimi glared at her. “Can you keep a secret?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I never tell!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was dark by the river; the moss hung thick from the trees. We heard a chicken squawking before we came upon the fortuneteller’s shack.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s where the werewolf lives,” Manette said, taking my hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked at Mimi. “Is this it?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("In front of the hut was a charcoal brazier. The air was thick with the smell of roasted goat. In the shadows of a verandah roofed over with banana ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("tree leaves, I saw an old Negro woman sitting cross-legged. Euphémie David—the voodoo priestess.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("As we approached she stood up. She was wearing a red satin ball gown fringed with gold, much tattered and stained and too big for her. Her hair was white and woolly, standing out around her head like a halo. A rusty machete was propped up against the wall behind her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mimi called out something I couldn’t understand. The old woman said something in the African tongue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What did she say?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Come,” the old woman said. A puppy came out of the shack and growled at us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll stay back here,” Manette said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mimi pushed me forward.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aren’t you coming too?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The two of us approached. What was there to be afraid of?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Entering the shade of the verandah, I was surprised how small the old woman was, not much bigger than Manette. Her loose black skin hung from her neck. She held a shell bowl in one hand—pigs’ knuckles and coconut, it looked like—and was eating it with her fingers. She threw a bone to the puppy to finish. The old woman and Mimi began talking in the African tongue. I looked back over my shoulder. Manette was standing by a calabash tree, watching. A crow called out warning sounds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mimi touched my arm. “She says your future is all around you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What does that mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The old woman went into the shack. She returned with a basket which she pushed into my hands. In the basket were a gourd rattle, a wooden doll, a stick, two candles, a bone, bits of frayed ribbon and a crucifix.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The old woman said something to Mimi.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She wants you to pick out three things,” Mimi told me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Anything?” I took a candle, the doll and the crucifix out of the basket.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She wants you to put them down,” Mimi said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In the dirt?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The old woman began chanting. I looked to see if Manette was still by the calabash tree. I shrugged at her. I remember thinking: "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("See, there is nothing to fear.")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("The old woman began to moan, rolling her head from side to side, the whites of her eyes cloudy. Then she looked at me and screamed—a sound I will never forget, not unlike a pig being stuck.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“What is it!” I demanded. I was not without fear. “Mimi! Why is she crying?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The old woman was shaking her head and mumbling. Finally she spoke, slowly, but strangely. “You will be unhappily married. You will be widowed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I put my hand to my throat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The old woman began to shake. She shook her hands, crying out words I could not understand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mimi, what is she saying!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The old woman began to dance, singing with the voice of a man. I backed away, stumbling over a gnarled tree root. I fell in the dirt and scrambled to my feet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("You will be Queen,")]), _vm._v(" she said.")]), _vm._v(" "), _c('hr', {
    staticClass: "hr"
  })]), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "fn16"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn-16"
    }
  }, [_vm._v("I")]), _vm._v(". "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("The family home was destroyed by a hurricane in 1766. They moved into the sucrerie, the building used to boil down sugar syrup.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-728235ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 75
// module chunks = 0